import { useState } from 'react';
import baseService from '../services/baseService';

const useContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const sendContactForm = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await baseService.post('/email/contact-us', formData);
      setSuccess(true);
    } catch (err) {
      setError(handleError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleError = (err) => {
    if (err.response) {
      return `${err.response.data.message}`;
    } else if (err.request) {
      return 'Error: No response from server';
    } else {
      return `Error: ${err.message}`;
    }
  };

  return { sendContactForm, loading, error, success };
};

export default useContactUs;